import { render, staticRenderFns } from "./monitorMsg.vue?vue&type=template&id=7af21c0b&"
import script from "./monitorMsg.vue?vue&type=script&lang=js&"
export * from "./monitorMsg.vue?vue&type=script&lang=js&"
import style0 from "./monitorMsg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports